import { TrainingStatusEnum } from '@geartracker/types';

import { createZodDto } from './zod';

import { z } from 'zod';

const TrainingFieldsSchema = z
  .object({
    name: z.string().min(1),
    description: z.string().nullable(),
    date: z.coerce.date(),
    expiryDate: z.coerce.date().nullable(),
    status: z.nativeEnum(TrainingStatusEnum),
    filesIds: z.number().array().default([]),
    // Lie cette formation, comme justificatif, à une habilitation déjà
    // existante du même salarié — pas de création imbriquée depuis ce
    // formulaire. Champ d'action write-only : jamais pré-rempli à l'édition,
    // voir HabilitationService.
    habilitationId: z.number().int().positive().nullable().default(null),
  })
  .strict();

const hasValidTrainingDates = (data: { date: Date; expiryDate: Date | null }) =>
  !data.expiryDate || data.expiryDate > data.date;

export const CreateTrainingSchema = TrainingFieldsSchema.extend({
  userId: z.number().int(),
}).refine(hasValidTrainingDates, {
  message: 'Expiry date must be after training date',
  path: ['expiryDate'],
});

// The employee is immutable once a training exists. A training can justify
// habilitations, so accepting a different user here could make another
// employee's training drive their compliance status.
export const UpdateTrainingSchema = TrainingFieldsSchema.refine(
  hasValidTrainingDates,
  {
    message: 'Expiry date must be after training date',
    path: ['expiryDate'],
  },
);

export class TrainingCreateDto extends createZodDto(CreateTrainingSchema) {}

export class TrainingUpdateDto extends createZodDto(UpdateTrainingSchema) {}
